import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "./Header";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import PhoneAuth from "./PhoneAuth";
import { useTranslation } from "react-i18next";

export default function Layout({ user, login, logout }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showAuth, setShowAuth] = useState(false);

  const handleAuthSuccess = (token, userData) => {
    login(token, userData);
    setShowAuth(false);
    navigate("/dashboard");
  };

  return (
    <>
      <Header
        user={user}
        logout={logout}
        onLoginClick={() => setShowAuth(true)}
      />
      <Outlet />
        <footer className="bg-gray-900 text-gray-300 py-10 px-6">
         <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white font-bold">
              FM
            </div>
            <span className="text-xl font-bold text-white">FixOurIndia</span>
          </div>

          <p className="text-gray-400">{t("home.footer")}</p>

          <div className="mt-5 text-sm text-gray-500">
            © {new Date().getFullYear()} FixOurIndia. All rights reserved.
          </div>
         </div>
        </footer>

      <Dialog open={showAuth} onOpenChange={setShowAuth}>
        <DialogContent data-testid="auth-modal">
          <DialogHeader>
            <DialogTitle>{t("auth.loginWithPhone")}</DialogTitle>
          </DialogHeader>

          <PhoneAuth
            onSuccess={handleAuthSuccess}
            onCancel={() => setShowAuth(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}